import type { HSLColor } from '@design-system/styles'
import { HSLColors, toHSL } from '@design-system/styles'
import React from 'react'

import type { iconList } from '../Icon'
import { Icon } from '../Icon'
import type { ButtonSize } from './_Button'
import { textButtonStyle, textIconTextButtonStyle } from './Button.style'

type TextButtonProps = {
  minWidth?: 80 | 100 | 120 | 144 | 160
  cpx?: number // 클릭영역 넓히는 패딩 x축 패딩 값
  cpy?: number // 클릭영역 넓히는 패딩 y축 패딩 값
  color?: 'default' | 'inverse'
  size?: Exclude<ButtonSize, 'xs'>
} & React.ComponentProps<'button'>

type IconTextProps = {
  minWidth?: 80 | 100 | 120 | 144 | 160
  cpx?: number
  cpy?: number
  hslColor?: HSLColor
  leftIcon: keyof typeof iconList
  size?: Exclude<ButtonSize, 'xs'>
} & Exclude<React.ComponentProps<'button'>, 'disabled' | 'color'>

type IconTextButtonProps = {
  cpTop?: number
  cpRight?: number
  cpBottom?: number
  cpLeft?: number
} & Exclude<IconTextProps, 'cpx' | 'cpy'>

export const TextButton = React.forwardRef<HTMLButtonElement, TextButtonProps>(
  ({ minWidth, size = 'm', children, cpx = 0, cpy = 7, color = 'default', ...props }, ref) => {
    return (
      <button
        ref={ref}
        css={textButtonStyle[color](size)}
        style={{ padding: `${cpy}px ${cpx}px`, margin: `-${cpy}px -${cpx}px` }}
        {...props}
      >
        <span className="inner-button">{children}</span>
      </button>
    )
  },
)

TextButton.displayName = 'TextButton'

export const IconTextButton = React.forwardRef<HTMLButtonElement, IconTextButtonProps>(
  (
    {
      minWidth,
      children,
      cpTop = 0,
      cpRight = 7,
      cpBottom = 0,
      cpLeft = 7,
      hslColor = HSLColors.gray.$600,
      leftIcon,
      size = 'm',
      ...props
    },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        css={textIconTextButtonStyle({ hslColor, size })}
        style={{
          padding: `${cpTop}px ${cpRight}px ${cpBottom}px ${cpLeft}px`, // TODO: css안으로 넣어서 important 낮추기
          margin: `-${cpTop}px -${cpRight}px -${cpBottom}px -${cpLeft}px`, // TODO: css안으로 넣어서 important 낮추기
        }}
        {...props}
      >
        <span className="inner-button">
          {
            <Icon
              name={leftIcon}
              size={size === 'l' ? 22 : size === 'm' ? 20 : size === 's' ? 18 : 20}
              color={toHSL(hslColor)}
              style={{ marginRight: 2 }}
            />
          }
          {children}
        </span>
      </button>
    )
  },
)
IconTextButton.displayName = 'IconTextButton'
